import * as types from '../actions/actionTypes';
import initialState from './initialState';
        
export default function cursoaprendizajeReducer(state= initialState.cursoaprendizaje, action){
    let newState;
	switch(action.type){
         case types.LOAD_CURSOAPRENDIZAJE_LIST_SUCCESS:		
            action.cursoaprendizaje.filtroActivo=state.filtroActivo;
            action.cursoaprendizaje.filtroActual=state.filtroActual;
            action.cursoaprendizaje.showActivos=state.showActivos;
			 action.cursoaprendizaje.paginaActual=action.cursoaprendizaje.pageable.pageNumber;
			 action.cursoaprendizaje.registrosPorPagina=action.cursoaprendizaje.size;
            
            return action.cursoaprendizaje;

        case types.BORRAR_CURSOAPRENDIZAJE_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursoaprendizaje => cursoaprendizaje.id !== action.cursoaprendizaje.id)];          
			return newState;    
            
        case types.ACTIVAR_CURSOAPRENDIZAJE_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(cursoaprendizaje => cursoaprendizaje.id !== action.cursoaprendizaje.id)];          
			 return newState;
            
        case types.SET_FILTRO_CURSOAPRENDIZAJE:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}